import { useTranslation } from "react-i18next";

import File from "../../../../../TableDetails/components/File";
import SingleDataItem from "../SingleDataItem";
import { GeneralFileDataProps } from "./types";

const GeneralFileData = ({ id, file }: GeneralFileDataProps) => {
    const { t } = useTranslation();

    return (
        <>
            <h4>{t("General##file data")}</h4>

            <SingleDataItem name={t("Table##file id")} data={id} />

            <File
                data={file}
                customCss={{
                    gridColumn: "1/-1",
                    marginTop: "4px"
                }}
            />
        </>
    );
};

export default GeneralFileData;
